import {
    CreateYandexStoryRequestType,
    YandexStoryFormFieldsEnum,
    YandexStoryFormType,
    YandexStoryStatusEnum,
} from './yandex-stories-type';

export function prepareCreateYandexStoryRequestData(data: YandexStoryFormType): CreateYandexStoryRequestType {
    const firstSlide = Object.values(data.slides).find((slide) => slide.order === 1);

    const cover =
        data[YandexStoryFormFieldsEnum.Cover] ||
        (firstSlide
            ? {
                  id: firstSlide.id,
                  url: firstSlide.url,
              }
            : {
                  id: '',
                  url: '',
              });

    return {
        selectorId: data[YandexStoryFormFieldsEnum.CompaniesSelector],
        name: data[YandexStoryFormFieldsEnum.Name],
        cover,
        slides: Object.values(data.slides).map((slide) => ({
            image: {
                id: slide.id,
                url: slide.url,
            },
            order: slide.order,
            buttonConfig: slide.buttonConfig,
        })),
        type: data.type,
        autoAddCompanies: data[YandexStoryFormFieldsEnum.AutoAddCompanies],
        // A filled publish date schedules the story (planned); otherwise publish now.
        status: data[YandexStoryFormFieldsEnum.PublishAt]
            ? YandexStoryStatusEnum.Planned
            : YandexStoryStatusEnum.InProgress,
        publishAt: data[YandexStoryFormFieldsEnum.PublishAt]
            ? data[YandexStoryFormFieldsEnum.PublishAt].toISOString()
            : null,
        deleteAt: data[YandexStoryFormFieldsEnum.DeleteAt]
            ? data[YandexStoryFormFieldsEnum.DeleteAt].toISOString()
            : null,
    };
}
